<template>
    <div>
        <span class="profile-image-container">
            <img
                class="profile-img"
                @click="changeProfile()"
                :class="[{'change-image': isEditing}]"
                :src="img">

            <input
                ref="fileProfile"
                type="file"
                class="file-profile"
                accept="image/png, image/jpeg, image/jpg"
                @change="onSelectFile">

        </span>
        <div class="change-image-container">
            <span
                v-if="isEditing"
                @click="changeProfile()"
                class="change-image pt-2">
                {{ $vuetify.lang.t('$vuetify.profile.change') }}
                <v-icon
                    size="16">
                    edit
                </v-icon>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Profile',

    props: {
        img: {
            type: String,
            default: ''
        },
        isEditing: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        changeProfile () {
            if (this.isEditing) {
                this.$refs.fileProfile.click()
            }
        },

        onSelectFile (files) {
            this.$emit('change-profile-img', files)
        }
    }
}
</script>

<style lang="scss" scoped>
.profile-image-container {
    display: block;
    background-color: #c7c7c7;
    width: 96px;
    height: 96px;
    border-radius: 50%;
}
.profile-img {
    width: 96px;
    border-radius: 50%;
    height: 95px;
    object-fit: contain;
}
.change-image {
    cursor: pointer;
}
.change-image-container {
    display: flex;
    justify-content: center;
}
.file-profile {
    display: none;
}
</style>
